import { Button, Dialog, Text } from '@servicetitan/anvil2';

export const CloseConfirmDialog = ({
    isOpen,
    onConfirm,
    onCancel,
}: {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}) => {
    return (
        <Dialog open={isOpen} onClose={onCancel}>
            <Dialog.Header>Discard unsaved changes?</Dialog.Header>
            <Dialog.Content>
                <Text>
                    Closing the application will discard your progress. This cannot be undone.
                </Text>
            </Dialog.Content>
            <Dialog.Footer>
                <Dialog.CancelButton>Cancel</Dialog.CancelButton>
                <Button appearance="danger" onClick={onConfirm}>
                    Discard Changes
                </Button>
            </Dialog.Footer>
        </Dialog>
    );
};
